import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ClerkService, ClerkSignUpComponent, SignUpProps } from "ngx-clerk-iliad";
import { AppUrlsService } from "../../../../services/app-urls.service";
import { BrandService } from "../../../../shared/branding/brand.service";

@Component({
  selector: "app-sign-up",
  imports: [ClerkSignUpComponent],
  template: ` <clerk-sign-up [props]="signUpProps" /> `,
})
export class SignUpComponent {
  public signUpProps: SignUpProps = {};

  constructor(
    private readonly brandService: BrandService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly appUrlsService: AppUrlsService,
    private readonly clerkService: ClerkService,
  ) {
    // If we interrupted navigation, make sure we send the user to the original destination after sign-up completes
    const userDestination = this.activatedRoute.snapshot.queryParamMap.get("dest");
    const destString = userDestination !== null ? `?dest=${encodeURIComponent(userDestination)}` : "";
    // Once sign-up is complete, redirect to signInRedirect, which will call /api/completeSignIn  on the
    // website API, which will finish setting up the user.
    const brand = this.brandService.brand();

    const signUpProps = {
      forceRedirectUrl: `${this.appUrlsService.websiteUrl}/signInRedirect${destString}`,
      appearance: {
        layout: {
          logoImageUrl: brand.logos.horizontalLogoLightMode,
        },
      },
    };

    if (this.appUrlsService.currentRootDomain !== this.appUrlsService.primaryRootDomain) {
      // If we're on a satellite domain, redirect the user to the primary domain's sign-up page.
      this.clerkService.redirectToSignUp({
        signUpForceRedirectUrl: signUpProps.forceRedirectUrl,
        signInForceRedirectUrl: signUpProps.forceRedirectUrl,
      });
    } else {
      this.signUpProps = signUpProps;
    }
  }
}
